<template>
  <section class="document-form">
    <div class="form-item">
      <span>Policyholder HKID</span>
      <file-container
        :edit="true"
        :fileData="formData.id_type_pic"
        :otherData="{
          target: 'id_type_pic'
        }"
        titleName= "Policyholder HKID"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
    <div class="form-item">
      <span>Contract</span>
      <file-container
        :edit="true"
        :fileData="formData.contract"
        :otherData="{
          target: 'contract'
        }"
        titleName= "Contract"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div>
    <!-- <div
      v-if="form.cust_typ == 2"
      class="form-item">
      <span>Certificate of Incorporation</span>
      <file-container
        :edit="true"
        :fileData="formData.cert_of_inc_pic"
        :otherData="{
          target: 'cert_of_inc_pic'
        }"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess" />
    </div> -->
    <div
      class="form-item">
      <span>Additional Documents</span>
      <file-container
        v-for="(item, index) in formData.other_file"
        :key="index"
        :edit="true"
        :fileData="item"
        :otherData="{
          index,
          target: 'other_file'
        }"
        titleName= "Additional Documents"
        @delete="handlerDeleteFile"
        @uploadSuccess="handlerUploadSuccess"
      />
      <v-upload
        :otherData="{
          type: 'other',
          target: 'other_file'
        }" 
        @uploadSuccess="handlerUploadSuccess" />
    </div>
  </section>
</template>
<script>
export default {
  name: 'DecorationDocumentForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        id_type_pic: {},
        contract: {},
        // cert_of_inc_pic: {},
        other_file: []
      }
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(JSON.stringify(val) != '{}') {
          if(this.formDataLock !== this.oldFormDataLock) {
            // 觸發更新就賦值，避免二次更新
            this.oldFormDataLock = this.formDataLock
            Object.keys(this.formData).some(key => {
              if(key in val) {
                this.formData[key] = JSON.parse(JSON.stringify(val[key]))
              }
            })
          }
        }
      }
    }
  },
  methods: {
    submitForm() {
      const { id_type_pic, contract, cert_of_inc_pic } = this.formData
      let params = JSON.parse(JSON.stringify(this.formData))
      if(id_type_pic) {
        params.id_type_pic_path = id_type_pic.path
        params.id_type_pic_path_id = id_type_pic.id
      }
      if(contract) {
        params.contract_path = contract.path
        params.contract_path_id = contract.id
      }
      // if(cert_of_inc_pic) {
      //   params.cert_of_inc_pic_path = cert_of_inc_pic.path
      //   params.cert_of_inc_pic_path_id = cert_of_inc_pic.id
      // }
      console.log(params, 'Interior Decoration')
      return params
    },
    handlerDeleteFile(otherData) {
      const { target, index = '' } = otherData
      if(index === '') {
        this.formData[target] = null
      } else {
        this.formData[target].splice(index, 1)
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, type, index = '' } = otherData
      if(type === 'other') {
        if(!this.formData[target]) {
          this.formData[target] = []
        }
        this.formData[target].push(data)
      }
      else if(index === '') {
        this.$set(this.formData, target, data)
      } else {
        this.$set(this.formData[target], index, data)
      }
    }
  }
}
</script>